import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Unauthorized from "../components/Unauthorized";

const EmpresasRoute = () => {
    const { userInfo } = useSelector((state) => state.auth)
    if(!userInfo){
        return(<Unauthorized />)
    }
    return <Outlet />
};

export default EmpresasRoute;